import React from 'react'
import "./Products.css"
const Products = () => {
  return (
    <div>Products</div>
  )
}

export default Products